module.exports = __webpack_public_path__ + "static/sponsorship_img-07-b-2778b2542202f2d535b3aa85af1cc7f5.jpg";